module.exports = __webpack_public_path__ + "img/TN.91251c44.svg";